import { observer } from 'mobx-react-lite'
import { useTextEnableLandlineStepsContext } from 'pages/settings/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineStepsContext'
import { AuthorizationDocumentCommon } from 'pages/settings/ui/AuthorizationDocumentCommon'

export const AuthorizationDocument = observer(() => {
  const { authorizationDocumentStore } = useTextEnableLandlineStepsContext()

  return <AuthorizationDocumentCommon authorizationDocumentStore={authorizationDocumentStore} />
})
